import { isFulfilled } from '@reduxjs/toolkit'
import { IFormPBMManagers } from 'legacy/lut/classes/models/partner360/IFormPBMManagers'
import {
  IRequestAcknowledgementParameters,
  requestAcknowledgement,
} from 'legacy/lut/features/partner360/commitment'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import { useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { NotificationController } from 'core-components/library/popup'

import { AcknowledgmentAction } from '../../enums/AckonwledgmentAction'
import { ICommitmentEditorItem } from '../../models'

import { ManagerDialog } from './CommitmentManagerDialog'

interface IProps {
  pbmToManager?: IFormPBMManagers
  onClose: () => void
  onApplyDone?: (res: ICommitmentData[]) => void
  show: boolean
  pbmList?: string[]
  action: AcknowledgmentAction
  ackItem?: ICommitmentEditorItem
  ackPartialInfo?: IObjectAny
  checkContactIsUnique: (email: string) => boolean
}

export const ManagerChangeDialog = ({
  pbmToManager,
  onClose,
  onApplyDone,
  show,
  pbmList,
  action,
  ackItem,
  ackPartialInfo,
  checkContactIsUnique,
}: IProps) => {
  const dispatch = useAppDispatch()

  const callAcknowledgmentAction = useCallback(
    (parameters: IRequestAcknowledgementParameters) => {
      if (
        (parameters.actionData.Action === AcknowledgmentAction.Change ||
          parameters.actionData.Action === AcknowledgmentAction.Add) &&
        parameters.actionData.Email &&
        !checkContactIsUnique(parameters.actionData.Email)
      ) {
        return
      }
      return dispatch(requestAcknowledgement(parameters))
    },
    [checkContactIsUnique, dispatch]
  )

  return (
    <ModalDialog
      show={show}
      size={'sm'}
      content={ManagerDialog}
      contentProps={{
        pbmList,
        item: pbmToManager,
        onApply: async (item: IFormPBMManagers) => {
          onClose()
          // Edited fields: ManagerFirstName, ManagerLastName, ManagerEmail
          try {
            if (ackItem) {
              const reduxAction = await callAcknowledgmentAction({
                partnerId: ackItem.PartnerId,
                fYear: ackItem.FYear,
                programType: ackItem.ProgramType,
                entryId: ackItem.EntryId,
                actionData: {
                  Action: action,
                  Email: item.ManagerEmail,
                  FirstName: item.ManagerFirstName,
                  LastName: item.ManagerLastName,
                  CommitmentType: ackItem.CommitmentType,
                },
              })
              if (onApplyDone) {
                if (isFulfilled(reduxAction)) {
                  await onApplyDone(reduxAction.payload)
                }
              }
            } else if (ackPartialInfo) {
              const reduxAction = await callAcknowledgmentAction({
                partnerId: ackPartialInfo.PartnerId,
                fYear: ackPartialInfo.FYear,
                programType: ackPartialInfo.ProgramType,
                entryId: null,
                actionData: {
                  Action: action,
                  Email: item.ManagerEmail,
                  FirstName: item.ManagerFirstName,
                  LastName: item.ManagerLastName,
                  CommitmentType: ackPartialInfo.CommitmentType,
                },
              })
              if (onApplyDone) {
                if (isFulfilled(reduxAction)) {
                  await onApplyDone(reduxAction.payload)
                }
              }
            }
          } catch (e: any) {
            NotificationController.showError({
              message: `Please, try again later. Error: ${e.message}`,
            })
          } finally {
            //loading(false) && setLoading(false)
          }
        },
      }}
      onClose={onClose}
    />
  )
}
